import { UPLOAD_FILE, REMOVE_FILE, API_FAIL, UPLOAD_FILE_REQUEST, UPLOAD_FILE_SUCCESS, UPLOAD_FILE_FAIL,
UPLOAD_PROFILE_IMG, UPLOAD_PROFILE_IMG_SUCCESS, UPLOAD_PROFILE_IMG_FAIL, 
DELETE_PROFILE_IMG, DELETE_PROFILE_IMG_SUCCESS, DELETE_PROFILE_IMG_FAIL

} from "./actionTypes"



export const uploadFileRequest = (data, callback) => {
  
  return {
    type: UPLOAD_FILE_REQUEST,
    payload: { data, callback },
  }
}

export const uploadFileSuccess = (data) => {
  return{
  type: UPLOAD_FILE_SUCCESS,
  payload: data,
}}
export const uploadFileFail = (error) => {return{
  type: UPLOAD_FILE_FAIL,
  payload: error,
}}

export const removeFile = fileId => {return{
  type: REMOVE_FILE,
  payload: fileId,
}}


export const uploadProfileImg = (data, callback) => {
  return {
    type: UPLOAD_PROFILE_IMG,
    payload: { data, callback },
  }
}

export const uploadProfileImgSuccess = (data) => {
  return{
  type: UPLOAD_PROFILE_IMG_SUCCESS,
  payload: data,
}}
export const uploadProfileImgFail = (error) => {return{
  type: UPLOAD_PROFILE_IMG_FAIL,
  payload: error,
}}




export const deleteProfileImg = (data, callback) => {
  return {
    type: DELETE_PROFILE_IMG,
    payload: { data, callback },
  }
}

export const deleteProfileImgSuccess = (data) => {
  return{
  type: DELETE_PROFILE_IMG_SUCCESS,
  payload: data,
}}
export const deleteProfileImgFail = (error) => {return{
  type: DELETE_PROFILE_IMG_FAIL,
  payload: error,
}}
